import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from './TableChooseComponent.jsx'

export default function TableChooseExternalComponent({columns, ...props}) {
    const enhancedColumns = [
        {
            title: '项目编号',
            dataIndex: 'prjNo',
            component: <Table.ViewText />,
        },

        {
            title: '项目名称',
            dataIndex: 'prjName',
            component: <Table.ViewText />,
        },

        ...columns
    ]

    return (
        <TableChooseComponent
            columns={enhancedColumns}
            rowKey="rowId"
            {...props}
        />
    )
}
